import React, { useState } from "react";
import AInput from "../../../../views/pages/manage/common/formFeilds/customInput/AInput";
const SEARCH_BY = [
  { key: "psid", value: "By PSID" },
  { key: "applicationId", value: "By Application ID" },
];

const dropdownStyle = {
  position: "absolute",
  margin: "auto 0px",
  background: "rgb(255, 246, 227)",
  color: "rgb(161, 114, 23)",
  border: "none",
  right: "2px",
  top: "2px",
  fontFamily: "Gilroy-Regular",
  fontSize: "12px",
  padding: "6px 2px",
  fontWeight: "800",
};

const StudentSearchBar = ({
  searchValue = "",
  onChange = () => {},
  onKeyDown = () => {},
  onSearchClick = () => {},
  dropdownValue = "psid",
  onDropdownChange = () => {},
  dropdownOptions = SEARCH_BY,
  width = "300px",
  dropdownStyles = {},
  rightIconStyles = {},
  showCross = false,
}) => {
  return (
    <AInput
      placeholder="Search"
      value={searchValue}
      handler={onChange}
      searchIconClickHandler={onSearchClick}
      crossIcon={showCross}
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          onKeyDown();
        }
      }}
      searchIcon={true}
      style={{ width, ...rightIconStyles }}
      customSearchIconStyle={{ left: "5px" }}
      rightCustomIcon={
        <select
          value={dropdownValue}
          onChange={(e) => {
            onDropdownChange(e.target.value);
            onDropdownChange(e.target.value);
          }}
          style={dropdownStyle}
        >
          {dropdownOptions.map(({ key, value }) => (
            <option key={key} value={key}>
              {value}
            </option>
          ))}
        </select>
      }
    />
  );
};

export default StudentSearchBar;
